<template>
  <div class="page page-with-tabs p-2">
    <page-header class="mb-0 brb-0">
      <template v-slot:title>
        <slot name="title"></slot>
      </template>
      <template v-slot:buttons>
        <slot name="buttons"></slot>
      </template>
    </page-header>

    <div class="view-body content-wrapper">
      <div class="custom-tabs nav-tabs-cont" ref="customTabs">
        <b-nav tabs ref="tabs">
          <div class="left-arrow hover-cursor" v-if="scrollable" @click="scrollLeft()">
            <font-awesome-icon class="icon" icon="chevron-left"/>
          </div>
          <template v-for="(tab, index) in tabs">
            <template v-if="!tab.children">
              <b-nav-item v-permission="tab.viewPermission" :to="tab.to" active-class="active" :key="index">
                <font-awesome-icon v-if="tab.icon" :icon="tab.icon" class="icon"/>
                {{ $t(tab.title) }}
              </b-nav-item>
            </template>
            <template v-else-if="hasAnyFinancePermission(tab.children)">
              <b-nav-item-dropdown :text="tab.title" right :toggle-class="{active: isDropdownActive(tab.children)}">
                <b-dropdown-item v-for="child in tab.children" active-class="active" :to="child.to" v-permission="child.viewPermission">
                  {{ child.title }}
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </template>
          </template>
          <div class="right-arrow hover-cursor" v-if="scrollable" @click="scrollRight()">
            <font-awesome-icon class="icon" icon="chevron-right"/>
          </div>
          <div class="ml-auto d-flex align-items-center pr-3">
            <slot name="right-placeholder"></slot>
          </div>
        </b-nav>
      </div>

      <div class="tab-content bg-white mt-2">
        <template v-if="$slots.content">
          <slot name="content"></slot>
        </template>
        <router-view v-else/>
      </div>
    </div>

    <slot></slot>

  </div>
</template>

<script>
  import PageHeader from "../../page-header/PageHeader";
  import Template from "@/modules/setup/templates/Templates";

  export default {
    name: "TabLayout",
    components: {Template, PageHeader},
    props: {
      tabs: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        scrollable: false,
      }
    },
    created() {
      this.isScrollable();
    },
    mounted() {
      this.$nextTick(function () {
        window.addEventListener('resize', this.isScrollable);
        this.isScrollable();
      })
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.isScrollable)
    },
    methods: {
      isDropdownActive(children) {
        for (let child of children) {
          if (child.to && child.to.name && child.to.name === this.$route.name) {
            return true;
          }
        }
        return false;
      },
      scrollLeft() {
        this.$refs.tabs.scrollLeft -= 200;
      },
      scrollRight() {
        this.$refs.tabs.scrollLeft += 200;
      },
      isScrollable() {
        if (this.$refs.tabs) {
          this.scrollable = this.$refs.tabs.clientWidth < this.$refs.tabs.scrollWidth;
          if (this.scrollable) {
            this.$refs.customTabs.style.paddingLeft = '2em'
            this.$refs.customTabs.style.paddingRight = '2em'
          } else {
            this.$refs.customTabs.style.padding = 0;
          }
        }
      },
      hasAnyFinancePermission(children) {
        for (let child of children) {
          if (this.$hasPermission(child.viewPermission)) {
            return true;
          }
        }
        return false;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .custom-tabs {
    .nav-item {
      &.dropdown {
        position: unset;

        /deep/ .dropdown-menu {
          margin-top: 45px;
        }
      }
    }

    &.nav-tabs-cont {
      border-top: 0.1em solid #e3e8ee;
      border-radius: 0 0 0.25rem 0.25rem;
      background: #ffffff;

      .nav-tabs {
        flex-wrap: nowrap;
        white-space: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-behavior: smooth;
        border: none;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      .left-arrow, .right-arrow {
        position: fixed;
        background: #ffffff;
        padding: 1em 0.8em;
        border-bottom: 2px solid #ffffff;
        margin-left: -2em;
      }

      .right-arrow {
        right: 16px;
        border-radius: 0 0 0.15rem 0;
        border-left: 1px solid #e3e8ee;
      }

      .left-arrow {
        border-radius: 0 0 0 0.15rem;
        border-right: 1px solid #e3e8ee;
      }
    }
  }
</style>
